/**
 * Validates a `?next=` return path before anything redirects to it.
 *
 * Same-origin relative paths only. The cases that catch people out are
 * protocol-relative: `//evil.com` and `/\evil.com` both pass a naive
 * `startsWith("/")` check, and browsers resolve either as an absolute URL to
 * another origin — backslashes are normalised to forward slashes in the
 * authority position. Hence the second character is checked too.
 *
 * Returns null for anything unusable, so every caller ends in
 * `safeNext(raw) ?? "/dashboard"` and an attacker-supplied value can only ever
 * degrade to the default.
 */
export function safeNext(raw: string | null | undefined): string | null {
  if (!raw || raw[0] !== "/") {
    return null;
  }
  if (raw[1] === "/" || raw[1] === "\\") {
    return null;
  }
  return raw;
}
